import React, { useMemo } from "react";
import { useLocation } from "react-router-dom";

// Red / White / Blue falling stars (Texas flag colors). Site-wide fixed overlay.
// Hidden on product detail pages so the product itself is the focus.
export default function SiteEffects({ count = 90 }) {
  const location = useLocation();
  const hideOn = location.pathname.startsWith("/product/");

  const stars = useMemo(() => {
    return Array.from({ length: count }).map((_, i) => {
      const left = Math.random() * 100;
      const delay = Math.random() * 16;
      const duration = 9 + Math.random() * 12;
      const size = 0.7 + Math.random() * 2.0;
      const opacity = 0.4 + Math.random() * 0.55;
      // Even-ish distribution across red, white, blue
      const r = Math.random();
      let color, shadow;
      if (r < 0.34) {
        color = "#E53935"; // adrenaline red
        shadow = "0 0 10px rgba(229,57,53,0.7), 0 0 4px rgba(229,57,53,0.5)";
      } else if (r < 0.67) {
        color = "#FFFFFF";
        shadow = "0 0 8px rgba(255,255,255,0.6), 0 0 3px rgba(255,255,255,0.5)";
      } else {
        color = "#3B82F6"; // texas blue (vibrant)
        shadow = "0 0 10px rgba(59,130,246,0.75), 0 0 4px rgba(59,130,246,0.5)";
      }
      return { i, left, delay, duration, size, opacity, color, shadow };
    });
  }, [count]);

  if (hideOn) return null;

  return (
    <div data-testid="site-effects" className="fixed inset-0 pointer-events-none overflow-hidden z-[5]" aria-hidden="true">
      {stars.map((s) => (
        <span
          key={s.i}
          className="fx-star"
          style={{
            left: `${s.left}%`,
            fontSize: `${s.size}rem`,
            opacity: s.opacity,
            animationDelay: `${s.delay}s`,
            animationDuration: `${s.duration}s`,
            color: s.color,
            textShadow: s.shadow,
          }}
        >★</span>
      ))}
    </div>
  );
}
